var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitraxLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "add79c65ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.601562 25 L 333.636719 25 L 333.636719 276 L 40.601562 276 Z M 40.601562 25 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add79c65ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 52.902344 127.289062 L 89.507812 190.75 L 50.285156 258.667969 L 40.601562 275.429688 L 163.976562 275.429688 L 154.292969 258.667969 L 115.070312 190.75 L 102.289062 168.753906 L 81.566406 133.003906 L 135.796875 133.003906 L 141.992188 143.566406 L 177.726562 205.765625 L 187.410156 222.042969 L 196.707031 205.765625 L 232.441406 143.566406 L 239.027344 133.003906 L 292.773438 133.003906 L 272.53125 168.753906 L 259.75 190.75 L 220.046875 258.667969 L 210.847656 275.429688 L 333.734375 275.429688 L 324.535156 258.667969 L 284.832031 190.75 L 321.4375 127.289062 L 331.121094 110.527344 L 238.640625 110.527344 L 196.804688 41.347656 L 187.507812 25.941406 L 177.824219 41.347656 L 135.988281 110.527344 L 43.507812 110.527344 L 53.191406 127.289062 Z M 154.679688 121.957031 L 187.3125 68.1875 L 219.464844 121.957031 L 187.3125 177.960938 Z M 248.515625 253.339844 L 272.339844 212.742188 L 295.675781 253.339844 Z M 78.855469 253.339844 L 102.191406 212.742188 L 125.53125 253.339844 Z M 78.855469 253.339844 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.6287, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.890625 0 L 16.90625 -4.671875 L 9.40625 -4.671875 L 8.375 0 L 0 0 L 8.046875 -31.28125 L 18.421875 -31.28125 L 26.46875 0 Z M 10.71875 -10.71875 L 15.59375 -10.71875 L 13.203125 -21.984375 Z M 10.71875 -10.71875 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.348315, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.90625 -19.59375 L 14.375 -19.59375 L 14.375 -24.609375 C 14.375 -25.328125 13.96875 -25.6875 13.15625 -25.6875 L 11.453125 -25.6875 C 10.640625 -25.6875 10.234375 -25.328125 10.234375 -24.609375 L 10.234375 -6.671875 C 10.234375 -5.960938 10.640625 -5.609375 11.453125 -5.609375 L 13.15625 -5.609375 C 13.96875 -5.609375 14.375 -5.960938 14.375 -6.671875 L 14.375 -11.5 L 22.90625 -11.5 L 22.90625 -6.046875 C 22.90625 -2.015625 20.515625 0 15.734375 0 L 8.875 0 C 4.09375 0 1.703125 -2.015625 1.703125 -6.046875 L 1.703125 -25.25 C 1.703125 -29.269531 4.09375 -31.28125 8.875 -31.28125 L 15.734375 -31.28125 C 20.515625 -31.28125 22.90625 -29.269531 22.90625 -25.25 Z M 22.90625 -19.59375 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.72894, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.8125 -31.28125 L 20.8125 -25.203125 L 14.765625 -25.203125 L 14.765625 0 L 6.234375 0 L 6.234375 -25.203125 L 0.25 -25.203125 L 0.25 -31.28125 Z M 20.8125 -31.28125 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.039649, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.953125 -31.28125 L 10.484375 -31.28125 L 10.484375 0 L 1.953125 0 Z M 1.953125 -31.28125 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.725346, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.765625 -31.28125 L 25.640625 -31.28125 L 17.9375 0 L 8.046875 0 L 0.34375 -31.28125 L 9.203125 -31.28125 L 12.96875 -10.375 Z M 16.765625 -31.28125 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.957663, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.953125 -31.28125 L 10.484375 -31.28125 L 10.484375 0 L 1.953125 0 Z M 1.953125 -31.28125 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.643359, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.8125 -31.28125 L 20.8125 -25.203125 L 14.765625 -25.203125 L 14.765625 0 L 6.234375 0 L 6.234375 -25.203125 L 0.25 -25.203125 L 0.25 -31.28125 Z M 20.8125 -31.28125 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(253.954069, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.484375 -11.109375 L 10.484375 0 L 1.953125 0 L 1.953125 -31.28125 L 16.421875 -31.28125 C 21.203125 -31.28125 23.59375 -29.269531 23.59375 -25.25 L 23.59375 -17.15625 C 23.59375 -14.070312 22.191406 -12.171875 19.390625 -11.453125 L 25.140625 0 L 15.984375 0 L 11.015625 -11.109375 Z M 13.84375 -25.203125 L 10.484375 -25.203125 L 10.484375 -16.90625 L 13.84375 -16.90625 C 14.65625 -16.90625 15.0625 -17.265625 15.0625 -17.984375 L 15.0625 -24.125 C 15.0625 -24.84375 14.65625 -25.203125 13.84375 -25.203125 Z M 13.84375 -25.203125 "
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(292.26054, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.890625 0 L 16.90625 -4.671875 L 9.40625 -4.671875 L 8.375 0 L 0 0 L 8.046875 -31.28125 L 18.421875 -31.28125 L 26.46875 0 Z M 10.71875 -10.71875 L 15.59375 -10.71875 L 13.203125 -21.984375 Z M 10.71875 -10.71875 "
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.980156, 334.20492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.25 -15.890625 L 25.390625 0 L 15.796875 0 L 12.421875 -8.765625 L 9.0625 0 L 0 0 L 7.65625 -15.890625 L 0.1875 -31.28125 L 9.84375 -31.28125 L 12.421875 -23.296875 L 15.0625 -31.28125 L 24.21875 -31.28125 Z M 17.25 -15.890625 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitraxLogoWhite);
export default __webpack_public_path__ + "static/media/activitrax-logo-white.3e75eb01e02f259722842ef3c022dc69.svg";
export { ForwardRef as ReactComponent };